import ScrollSmoother from "gsap/ScrollSmoother";

export function scrollToSection(sectionId) {
  const el = document.getElementById(sectionId);
  if (!el) return;

  const smoother = ScrollSmoother.get();
  if (smoother) {
    smoother.scrollTo(el, true, "top 100px");
    return;
  }

  el.scrollIntoView({ behavior: "smooth" });
}

export function navigateToHomeSection(navigate, sectionId) {
  if (window.location.pathname === "/") {
    scrollToSection(sectionId);
  } else {
    sessionStorage.setItem("scrollTo", sectionId);
    navigate("/");
  }
}
